import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { QualityControlCathodic, RepositoryModal } from '../../../shared'
import { CathodicComponent } from './cathodic.component'

@Component({
    templateUrl: './cathodic-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class CathodicModalComponent extends RepositoryModal<QualityControlCathodic> implements OnInit {
    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as CathodicComponent

        if (this.isAdding) {
            this.target.job = parentComponent.selectedJob()
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) {
            this.services.notification.warning('Job is required')
            return false
        }
        return true
    }
}
